import { Brief2PipeProps } from "./index8.js";
import { _defineProperty } from "./index13.js";
import { getRgVersions } from "./index194.js";
import { aggPropsToDto as aggPropsToDto$1 } from "./index201.js";
import { rgBriefToDto as rgBriefToDto$1 } from "./index202.js";
import { getShallowRgObj } from "./index235.js";
import { GetAllBones, RG_TYPE, getRgObjectsOfType } from "@project-rouge/rg-core";
import { dequal } from "dequal";
var AggManagerBase = class {
	constructor() {
		_defineProperty(this, "brief", void 0);
		_defineProperty(this, "internalDOs", []);
		_defineProperty(this, "_designOptions", []);
		_defineProperty(this, "internalIndex", -1);
		_defineProperty(this, "cache", []);
	}
	get designOptions() {
		return this._designOptions.slice();
	}
	getBrief() {
		return this.brief;
	}
	setBrief(brief) {
		if (this.brief === brief) return;
		this.brief = brief;
		this.clearDesignOptions();
	}
	clearDesignOptions() {
		this.internalDOs.length = 0;
		this.internalIndex = -1;
		this._designOptions.length = 0;
		this.cache.length = 0;
	}
	async generateNext() {
		if (!this.brief) throw new Error("brief is undefined");
		this.internalIndex++;
		const pipeProps = Brief2PipeProps({
			brief: this.brief,
			start: this.internalIndex,
			count: 1
		})[0];
		const internalDO = {
			id: crypto.randomUUID(),
			briefIndex: this.internalIndex,
			aggProps: pipeProps.aggProps
		};
		this.internalDOs.push(internalDO);
		const { result, meta } = await this.generate(this.brief.obj, internalDO.aggProps, this.internalIndex);
		const shallowResult = getShallowRgObj(result);
		const bones = getRgObjectsOfType(result, RG_TYPE.Building).flatMap((b) => GetAllBones(b.data.anatomy));
		const duplicateOf = this.isDuplicate(shallowResult);
		internalDO.bones = bones;
		internalDO.obj = await this.compressRgObject(result);
		internalDO.duplicateOf = duplicateOf;
		internalDO.empty = bones.length === 0;
		internalDO.shallowResult = duplicateOf ? void 0 : shallowResult;
		internalDO.meta = meta;
		const designOption = getDesignOptionFromInternal(internalDO);
		this._designOptions.push(designOption);
		return designOption;
	}
	async getAggDebugDto(briefIndex, includeDesignOption = false) {
		let designOption = this.internalDOs.find((d) => d.briefIndex === briefIndex);
		if (!designOption) designOption = {
			id: "",
			briefIndex,
			aggProps: Brief2PipeProps({
				brief: this.brief,
				start: briefIndex,
				count: 1
			})[0].aggProps
		};
		const aggDebugDto = {
			versions: getRgVersions(),
			briefDto: rgBriefToDto$1(this.brief),
			aggPropsDto: aggPropsToDto$1(designOption.aggProps),
			briefIndex: designOption.briefIndex
		};
		if (includeDesignOption && designOption.obj) aggDebugDto.designOption = await this.decompressRgObjectDto(designOption.obj);
		return aggDebugDto;
	}
	isDuplicate(obj) {
		for (const option of this.internalDOs) {
			if (!option.shallowResult) continue;
			if (dequal(obj, option.shallowResult)) return option.briefIndex;
		}
	}
};
function getDesignOptionFromInternal(internalDo) {
	return {
		id: internalDo.id,
		briefIndex: internalDo.briefIndex,
		aggProps: internalDo.aggProps,
		bones: internalDo.bones,
		obj: internalDo.obj,
		duplicateOf: internalDo.duplicateOf,
		empty: internalDo.empty,
		meta: internalDo.meta
	};
}
export { AggManagerBase };

//# sourceMappingURL=index237.js.map